import { VolunteersTableController } from "@controllers/VolunteersTable.controller";
import { type Association } from "@entities";
import { associationRepo } from "@repositories";
import { type HyperTableDef } from "@shared/frontend/hyper-table";
import { type Severity } from "clients/admin/src/desktop/contexts/AlertProvider";
import { type Question } from "clients/admin/src/desktop/dialog-components/QuestionDialog";
import type { EntityFilter } from "remult";

export async function changeVolunteersStatus(
  status: "ACTIVE" | "INACTIVE" | "NEW" | "LEGACY",
  setAlertText: React.Dispatch<React.SetStateAction<string>>,
  setSeverity: React.Dispatch<React.SetStateAction<Severity>>,
  setStatusAnchor: React.Dispatch<React.SetStateAction<EventTarget | null>>,
  hyperTable: HyperTableDef<Association>,
) {
  try {
    await associationRepo.updateMany({
      where: hyperTable.context?.current?.allSelected
        ? (hyperTable.context?.current?.finalWhere as EntityFilter<Association>)
        : associationRepo.metadata.idMetadata.getIdFilter(
            ...hyperTable.context?.current?.selectedIds!,
          ),
      set: {
        activityStatus: status as "ACTIVE" | "NEW" | "INACTIVE" | "LEGACY",
      },
    });
    setSeverity("success");
    setAlertText("הסטטוס השתנה בהצלחה");
    hyperTable.context?.current?.refetch("remove");
  } catch {
    setAlertText("קרתה תקלה, אנא נסו שנית במועד מאוחר יותר");
  } finally {
    if (setStatusAnchor) setStatusAnchor(null);
    hyperTable.context?.current?.table.toggleAllRowsSelected(false);
  }
}

export async function archiveUsers(
  where: EntityFilter<Association>,
  question: Question,
  HyperTable: HyperTableDef<Association>,
  setAlertText: React.Dispatch<React.SetStateAction<string>>,
  setSeverity: React.Dispatch<React.SetStateAction<Severity>>,
) {
  if (
    await question("האם אתה בטוח שברצונך להעביר את המתנדבים הנבחרים להיסטוריה?")
  ) {
    try {
      await associationRepo.updateMany({
        where,
        set: { isDeleted: true },
      });
      setAlertText("המתנדבים הועברו להיסטוריה בהצלחה");
      setSeverity("success");
    } catch {
      setAlertText("קרתה תקלה, אנא נסו שנית במועד מאוחר יותר");
      setSeverity("error");
    } finally {
      HyperTable.context?.current?.table.toggleAllRowsSelected(false);
      HyperTable.context?.current?.refetch("remove");
    }
  }
}

export async function restoreUsers(
  where: EntityFilter<Association>,
  question: Question,
  HyperTable: HyperTableDef<Association>,
  setAlertText: React.Dispatch<React.SetStateAction<string>>,
  setSeverity: React.Dispatch<React.SetStateAction<Severity>>,
) {
  if (await question("האם ברצונך לשחזר מתנדבים אלו?")) {
    try {
      await associationRepo.updateMany({
        where,
        set: { isDeleted: false },
      });
      setAlertText("המתנדבים שוחזרו בהצלחה");
      setSeverity("success");
    } catch {
      setAlertText("קרתה תקלה, אנא נסו שנית במועד מאוחר יותר");
      setSeverity("error");
    } finally {
      HyperTable.context?.current?.table.toggleAllRowsSelected(false);
      HyperTable.context?.current?.refetch("remove");
    }
  }
}

export async function handleTeamsSave(
  where: EntityFilter<Association>,
  teams: string[],
  HyperTable: HyperTableDef<Association>,
) {
  try {
    await VolunteersTableController.saveTeams(where, teams);
    HyperTable.context?.current?.refetch("remove");
    HyperTable.context?.current?.table.toggleAllRowsSelected(false);
  } catch {
    // SetAlertText("קרתה תקלה, אנא נסו שנית במועד מאוחר יותר");
  } finally {
    // Table.toggleAllRowsSelected(false);
  }
}

export async function handleOpportunitiesSelect(
  selected: string[],
  where: EntityFilter<Association>,
) {
  await VolunteersTableController.handleOpportunitiesSelect(selected, where);
}
